import { useMemo } from "react"
import { useModelMetadata } from "resources/models"
import { get, compact } from "lodash"

export function useModelBetaFields(modelId) {
  const [modelMetadata, modelMetadataStatus] = useModelMetadata(modelId)
  const missingDataFiles = get(modelMetadata, "missingDataFiles", [])

  const betaFields = useMemo(() => compact([
    (!missingDataFiles.includes("predictedBeta") && "predicted"),
    (!missingDataFiles.includes("historicalBeta") && "historical"),
  ]), [missingDataFiles])

  return [betaFields, modelMetadataStatus]
}
